/**
 * competencyGrowthCopy — calm-copy resolver for the lesson-timer
 * coaching-awareness badge.
 *
 * Stage-2 P3 enhancement (Feb 18, 2026). Pure logic, no React, no
 * network. Separating this from the component keeps the unit test
 * free of axios/ESM transform woes.
 *
 * Branch order (first match wins):
 *   1. today_count > 0          → "N opportunit(y|ies) noticed"
 *   2. top prompts deduped       → "Today: <a>" or "Today: <a> + <b>"
 *   3. any context set           → "Focus active"
 *   4. otherwise                 → null  (badge hides)
 *
 * Vocabulary rules:
 *   • Never a percentage, never pass/fail, never "competencies
 *     completed", never gamified.
 *   • Lowercase competency labels for calm typography.
 */
export function buildCalmCopy({ summary, prompts, ctx } = {}) {
  const todayCount = Number(summary?.today_count || 0);
  if (todayCount > 0) {
    const noun = todayCount === 1 ? "opportunity" : "opportunities";
    return `${todayCount} ${noun} noticed`;
  }

  const labels = [];
  const seen = new Set();
  for (const p of (prompts?.prompts || [])) {
    const label = (p?.competency_label || "").trim().toLowerCase();
    if (!label || seen.has(label)) continue;
    seen.add(label);
    labels.push(label);
    if (labels.length >= 2) break;
  }
  if (labels.length === 2) return `Today: ${labels[0]} + ${labels[1]}`;
  if (labels.length === 1) return `Today: ${labels[0]}`;

  const hasContext = Boolean(
    ctx?.focus || ctx?.environment || ctx?.complexity || ctx?.stage,
  );
  if (hasContext) return "Focus active";
  return null;
}


export function copyMode(copy) {
  if (!copy) return null;
  if (copy.startsWith("Today:")) return "competencies";
  if (copy === "Focus active")    return "context";
  return "count";
}
